define('SessionKeepAlive.Settings', [], function () {
  'use strict';

  var MINUTE = 60 * 1000;
  var HOUR = 60 * MINUTE;
  var NATIVE_IDLE_MS = 20 * MINUTE;

  var LIMITS = {
    maxSessionHours: { min: 0.25, max: 12, fallback: 8 },
    pingIntervalMinutes: { min: 1, max: 10, fallback: 2 }
  };

  function getConfigValue(environment, key) {
    if (!environment || !environment.getConfig) {
      return null;
    }
    return environment.getConfig('sessionKeepAlive.' + key);
  }

  function toBoolean(value, fallback) {
    if (value === true || value === 'T' || value === 'true') {
      return true;
    }
    if (value === false || value === 'F' || value === 'false') {
      return false;
    }
    return fallback;
  }

  function clamp(value, limit) {
    var number = parseFloat(value);
    if (isNaN(number)) {
      return limit.fallback;
    }
    return Math.min(limit.max, Math.max(limit.min, number));
  }

  function read(environment) {
    var hours = clamp(getConfigValue(environment, 'maxSessionHours'), LIMITS.maxSessionHours);
    var minutes = clamp(getConfigValue(environment, 'pingIntervalMinutes'), LIMITS.pingIntervalMinutes);

    return {
      enabled: toBoolean(getConfigValue(environment, 'enabled'), false),
      maxSessionMs: hours * HOUR,
      pingIntervalMs: Math.round(minutes) * MINUTE,
      requireActivity: toBoolean(getConfigValue(environment, 'requireActivity'), false),
      logoutAtMax: toBoolean(getConfigValue(environment, 'logoutAtMax'), false)
    };
  }

  return {
    NATIVE_IDLE_MS: NATIVE_IDLE_MS,
    read: read
  };
});
